/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { Input, InputAdornment, Box } from "@mui/material";
import { ReactComponent as TableSearchIcon } from "../../assets/icons/table-search.svg";
import Dropdown from "cms/shared/dropdown";
import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";

const MUNICIPALITY_LIST_KEY = "four_muni_list";

const SearchFilterBar = (props) => {
    const { token } = useAuth();
    const handleSearchInputChange = props?.onSearchInputChange;
    const handleSearchTrigger = props?.onSearchTrigger;
    const handleMunicipalityChange = props?.onMunicipalityChange;
    const currentSearchInput = props?.searchInput;
    const currentSelectedMunicipality = props?.selectedMunicipality;

    const initialOptions = [
        { value: "All municipalities", label: "All municipalities" }
    ];

    const [municipalityOptions, setMunicipalityOptions] = useState(initialOptions);

    useEffect(() => {
        const fetchMunicipalityOptions = async () => {
            try {
                const response = await SimpliCitySDK.list.findOneByKey(token, MUNICIPALITY_LIST_KEY);
                const options = [...initialOptions];
                for (const option of response) {
                    options.push({
                        value: option,
                        label: option
                    });
                }
                setMunicipalityOptions(options);
            } catch (error) {
                // Fallback to default options if API fails
                setMunicipalityOptions([
                    { value: "All municipalities", label: "All municipalities" }
                ]);
            }
        };
        fetchMunicipalityOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const handleSearchFieldChange = (event) => {
        const inputValue = event?.target?.value || "";
        if (handleSearchInputChange) {
            handleSearchInputChange(inputValue);
        }
    };

    const handleSearchFieldKeyPress = (event) => {
        if (event.key === "Enter") {
            if (handleSearchTrigger) {
                handleSearchTrigger();
            }
        }
    };

    const handleSearchIconClick = () => {
        if (handleSearchTrigger) {
            handleSearchTrigger();
        }
    };

    const handleMunicipalityDropdownChange = (event) => {
        const selectedValue = event?.target?.value || "All municipalities";
        if (handleMunicipalityChange) {
            handleMunicipalityChange(selectedValue);
        }
        if (handleSearchTrigger) {
            handleSearchTrigger();
        }
    };

    return (
        <div className='simplicity-search-filter-bar'>
            <div className='simplicity-search-filter-dropdown'>
                <Dropdown
                    width="100%"
                    value={currentSelectedMunicipality}
                    onChange={handleMunicipalityDropdownChange}
                    options={municipalityOptions}
                />
            </div>
            <div className='simplicity-search-filter-input'>
                <Input
                    className="search-input"
                    placeholder="Search for a ticket number, disputant..."
                    value={currentSearchInput}
                    onChange={handleSearchFieldChange}
                    onKeyPress={handleSearchFieldKeyPress}
                    disableUnderline
                    endAdornment={
                        <InputAdornment position="end">
                            <Box
                                component={TableSearchIcon}
                                className="search-icon"
                                onClick={handleSearchIconClick}
                            />
                        </InputAdornment>
                    }
                />
            </div>
        </div>
    );
};

SearchFilterBar.displayName = "SearchFilterBar";
export { SearchFilterBar };
